const REACT_APP_URL = process.env.REACT_APP_URL;
const BASE_URL_PRIVATE = REACT_APP_URL + (navigator.language.slice(0,2) ?? 'es') + '/api/private/';
export default class Urls {
    public static URL_GET_DASHBOARD = `${BASE_URL_PRIVATE}dashboard`;
    public static URL_GET_MESSAGES = `${BASE_URL_PRIVATE}messages`;
}